import * as React from "react";
import { forwardRef } from "react";
const SvgChartOfAccounts = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M25.3331 26.1538C25.3331 26.6435 25.1543 27.113 24.8361 27.4593C24.5179 27.8055 24.0862 28 23.6362 28H8.36347C7.91341 28 7.48178 27.8055 7.16353 27.4593C6.84529 27.113 6.6665 26.6435 6.6665 26.1538V5.8462C6.6665 5.35657 6.84529 4.88699 7.16353 4.54077C7.48178 4.19455 7.91341 4.00005 8.36347 4.00005H15.9701C16.5298 4.00005 17.0638 4.23454 17.4426 4.64658L24.8056 12.6569C25.1449 13.026 25.3331 13.509 25.3331 14.0103V26.1538Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.9028 11.3846H15.3937",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.9028 16.9232H20.6301",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.9028 22.4616H20.6301",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgChartOfAccounts);
export default ForwardRef;
